Shopify.AjaxCart = {
	settings: {

		// cartTotalPrice: ,
		vat_rate: 20,

		shippingPrice: 0,
		shippingPriceDisplay: '&pound;0.00',

		freeShippingThreshold: 0
	},

	translations: {
		"title": "Shopping Cart",
		"cart": {
			"empty_cart": "Your Cart is Empty",
			"loading": "Loading"
		},
		"shipping_banner": {
			"text_required_html": "Spend SHIPPING_PRICE more to get free shipping",
			"text_free_html": "Congrats! You qualify for free shipping."
		},
		"cart_notes": {
			"title": "Order Notes",
			"view_terms": "View terms",
			"agree_to_terms": "I agree with the terms and conditions."
		},
		"statement": {
			"label_shipping": "Shipping",
			"label_savings": "Savings",
			"label_subtotal": "Subtotal",
			"label_total": "Total"
		},
		"buttons": {
			"cart": "Translation missing: en.ajax-cart.buttons.cart",
			"checkout": "Check Out"
		},
		"upsells": {
			"mailing_carton": {
				"out_of_stock": "Sorry - the mailing carton for this product is not available right now."
			}
		}
	},

	storage: {

		cart: null

	},

	api: {

		getMailingCartonProduct: function(options) {

			var settings = $.extend({}, options);

			var handle = settings.handle;
			var quantity = settings.quantity;
			var id = settings.id;

			var data = {
				quantity: quantity,
				id: id
			};

			$.ajax({
				url: '/products/' + handle + '.js',
				type: 'get',
				dataType: 'json',
				beforeSend: function(){

					Shopify.AjaxCart.functions.cartOverlayShow();

					$("#ajax-cart").trigger("ajax-cart.get-product.before");

					if (typeof settings.beforeSend === 'function') {
						settings.beforeSend();
					}

				},
				error: function(){

					Shopify.AjaxCart.functions.cartOverlayHide();

					$("#ajax-cart").trigger("ajax-cart.get-product.error");

					if (typeof settings.error === 'function') {
						settings.error();
					}

				},
				success: function (data) {

					$("#ajax-cart").trigger("ajax-cart.get-product.success");

					if (typeof settings.success === 'function') {
						settings.success(data);
					}

				}
			});

		},

		getAllMailingCartonProducts: function(options) {

			var settings = $.extend({}, options);

			var handle = settings.handle;
			var quantity = settings.quantity;
			var id = settings.id;

			var data = {
				quantity: quantity,
				id: id
			};

			$.ajax({
				url: '/products/' + handle + '.js',
				type: 'get',
				dataType: 'json',
				beforeSend: function(){

					Shopify.AjaxCart.functions.cartOverlayShow();

					$("#ajax-cart").trigger("ajax-cart.get-product.before");

					if (typeof settings.beforeSend === 'function') {
						settings.beforeSend();
					}

				},
				error: function(){

					Shopify.AjaxCart.functions.cartOverlayHide();

					$("#ajax-cart").trigger("ajax-cart.get-product.error");

					if (typeof settings.error === 'function') {
						settings.error();
					}

				},
				success: function (data) {

					$("#ajax-cart").trigger("ajax-cart.get-product.success");

					if (typeof settings.success === 'function') {
						settings.success(data);
					}

				}
			});

		},

		addItem: function(options){

			var settings = $.extend({}, options);

			var quantity = settings.quantity;
			var id = settings.id;

			var data = {
				quantity: quantity,
				id: id
			};

			$.ajax({
				url: '/cart/add.js',
				type: 'post',
				dataType: 'json',
				data: data,
				beforeSend: function(){

					Shopify.AjaxCart.functions.cartOverlayShow();

					$("#ajax-cart").trigger("ajax-cart.add-item.before");

					if (typeof settings.beforeSend === 'function') {
						settings.beforeSend();
					}

				},
				error: function(){

					Shopify.AjaxCart.functions.cartOverlayHide();

					$("#ajax-cart").trigger("ajax-cart.add-item.error");

					if (typeof settings.error === 'function') {
						settings.error();
					}

				},
				success: function (data) {

					Shopify.AjaxCart.api.updateCart({
						success: function(){
							// Scroll to bottom
							$('.ajax-cart__body').scrollTop($('.ajax-cart__body')[0].scrollHeight);
						}
					});

					$("#ajax-cart").trigger("ajax-cart.add-item.success");

					if (typeof settings.success === 'function') {
						settings.success();
					}

				}
			});

		},

		changeItemQuantity: function(options){

			var settings = $.extend({}, options)

			var quantity = settings.quantity;
			var id = settings.id;

			var data = {
				quantity: quantity,
				id: id
			};

			$.ajax({
				url: '/cart/change.js',
				dataType: 'json',
				cache: false,
				type: 'post',
				data: data,
				error: function(){

					$("#ajax-cart").trigger("ajax-cart.change-item.error", [data]);

					if (typeof settings.error === 'function') {
						settings.error();
					}

				},
				beforeSend: function(){

					Shopify.AjaxCart.functions.cartOverlayShow();

					$("#ajax-cart").trigger("ajax-cart.change-item.before", [data]);

					if (typeof settings.beforeSend === 'function') {
						settings.beforeSend();
					}

				},
				success: function (data) {

					Shopify.AjaxCart.api.updateCart();

					$("#ajax-cart").trigger("ajax-cart.change-item.success", [data]);

					if (typeof settings.success === 'function') {
						settings.success();
					}

				}
			});

		},

		updateCart: function(options){

			var settings = $.extend({}, options)

			$.ajax({
				url: '/cart.js',
				dataType: "json",
				cache: false,
				error: function(){

					$("#ajax-cart").trigger("ajax-cart.update-cart.error");

					if (typeof settings.error === 'function') {
						settings.error();
					}

				},
				beforeSend: function(){

					Shopify.AjaxCart.functions.cartOverlayShow();

					$("#ajax-cart").trigger("ajax-cart.update-cart.before");

					if (typeof settings.beforeSend === 'function') {
						settings.beforeSend();
					}

				},
				complete: function(){

					Shopify.AjaxCart.functions.cartOverlayHide();

					if (typeof settings.complete === 'function') {
						settings.complete();
					}

				},
				success: function(data){

					Shopify.AjaxCart.storage.cart = data;
					Shopify.AjaxCart.functions.refreshShipping();
					Shopify.AjaxCart.functions.refreshCart();
					Shopify.AjaxCart.functions.refreshTotals();

					$("#ajax-cart").trigger("ajax-cart.update-cart.success", [data]);

					if (typeof settings.success === 'function') {
						settings.success(data);
					}

				}
			});

		}

	},

	templates: {

		cartItem: function(data){

      var mailingCartonsDisplay = false;

			var id = data.id;
			var handle = data.handle;
			var type = data.product_type;

      var min = 0;
      var is_usa = $("#ajax-cart").data('is_usa');

      if( type == 'Box' && is_usa == 'true'){
        min = 2;
      }

			var image = data.image;
			var title = data.product_title;
			var price = data.price;
			var price_formatted = Shopify.formatMoney(price, $('body').data('money-format'));
			var quantity = data.quantity;
			var quantity_badge_class;
			var quantity_badge_number;
			var url = data.url;
			var variants = data.variant_options;

			var isSample = (title.indexOf("Sample") != -1 || title.indexOf("sample") != -1);
			var isSampleHTML;

			if (isSample == true) {
				isSampleHTML = 'data-sample="true"'
			}

			if ((type == "Closure" || type == "Photo Frame" || type == "Button") && isSample == false) {
				quantity_badge_number = 6;
				quantity_badge_class = "quantity-badge--primary";
			}
			else
			if ((type == "Box" || type == "Dividers" ) && isSample == false ) {
				quantity_badge_number = 12;
				quantity_badge_class = "quantity-badge--secondary";
			}
			else
			if ((type == "Mailing Carton" || type == "Ribbon" ) && isSample == false ) {
				quantity_badge_number = 24;
				quantity_badge_class = "quantity-badge--tertiary";
			}
			else {
				quantity_badge_number = 1
			}

			var html = "";

			html +=  '<div class="ajax-cart-item" data-id="' + id + '" data-handle="' + handle + '" data-type="'+ type +'">';
			html +=    '<div class="ajax-cart-item__image">';

			if (image) {
			html +=        '<a href="' + url + '">';
			html +=          '<img src="' + image + '" alt="' + title + '"/>';
			html +=        '</a>';
			}

			if (quantity_badge_number > 1) {
				html +=   	 '<div class="ajax-cart-item__quantity-badge quantity-badge ' + quantity_badge_class + '">';
				html +=   	 		quantity_badge_number;
				html +=   	 '</div>';
			}

			html +=    '</div>';

			html +=    '<div class="ajax-cart-item__properties">';
			html +=      '<a class="ajax-cart-item__link" href="' + url + '">';
			html +=        '<div class="ajax-cart-item__title">' + title + '</div>';
			html +=      '</a>';
			html +=      '<div class="ajax-cart-item__variants">';

			if (variants[0] !== "Default Title") {
				for (var i = 0; i < variants.length; i++) {
					html += variants[i] + '<br>';
				}
			}

			html +=      '</div>';
			html +=      '<div class="ajax-cart-quantity-selector">';
			html +=        '<span class="ajax-cart-quantity-selector__button ajax-cart-quantity-selector__decrement">-</span>';
			html +=        '<input class="ajax-cart-quantity-selector__quantity" type="number" min="' + min + '" size="2" name="updates[]" id="updates_' + id + '" value="' + quantity + '" data-line-id=""/>';
			html +=        '<span class="ajax-cart-quantity-selector__button ajax-cart-quantity-selector__increment">+</span>';
			html +=      '</div>';

			if (type == "Box" && mailingCartonsDisplay == true) {

				html +=				'<div class="ajax-cart-item__upsell-container">';
				html +=					'<button title="Add a mailing cartons for this box." type="button" class="action_button action_button--tertiary action_button--tiny ajax-cart--trigger-add-mailing-carton tooltipster" ' + isSampleHTML + '>';
				html +=						'<span class="action_button__text">Add Mailing Carton</span>';
				html +=						'<span class="action_button__icon"><span class="icon-plus"></span></span>';
				html +=					'</button>';
				html +=				'</div>';

			}

			html +=      '<strong class="ajax-cart-item__price">';

			if (price) {
				html +=          '<span class="money was_price"></span>';
			}

			html +=        '<span class="money">' + price_formatted + '</span>';
			html +=      '</strong>';
			html +=      '<span tabindex="0" class="ajax-cart-item__remove">Remove</span>';
			html +=    '</div>';
			html +=  '</div>';

			return html;

		},

		cartEmptyMessage: function(){

			var html = "";

			html += '<div class="ajax-cart-empty-message">';
			html +=   '<span class="ajax-cart-empty-message__icon"></span>';
			html +=   '<span class="ajax-cart-empty-message__text">' + Shopify.AjaxCart.translations.cart.empty_cart + '</span>';
			html += '</div>';

			return html;

		},

		cartContentsOverlay: function(options){

			var text = Shopify.AjaxCart.translations.cart.loading;

			if (typeof options != "undefined") {
				if (typeof options.text === "string") {
					text = options.text;
				}
			}

			var html = "";

			html +=  '<div class="ajax-cart-contents-overlay">';
			html +=    '<div class="ajax-cart-contents-overlay__content">';
			html +=      '<div class="ajax-cart-contents-overlay__icon animation--pulse"><img src="//www.foldabox.co.uk/cdn/shop/t/172/assets/ajax-cart-loading.svg?v=2313204295009146971716282359" alt="Loading... />"</div>';
			// html +=      '<div class="ajax-cart-contents-overlay__text">Loading...</div>';
			html +=    '</div>';
			html +=  '</div>';

			return html;

		},

	},

	functions: {

		cartToggle: function(e){

			var open = $('.ajax-cart').hasClass('ajax-cart--opened') === true;

			if (open === true) {
				Shopify.AjaxCart.eventHandlers.cartClose();
			}
			else {
				Shopify.AjaxCart.eventHandlers.cartOpen();
			}

		},

		cartOpen: function(e){

			$(".ajax-cart")
				.addClass('ajax-cart--opened')
				.removeClass('ajax-cart--closed');

			$(".ajax-cart-overlay").fadeIn();

			$("#ajax-cart").trigger("ajax-cart.cart-open");

			$("body").addClass("ajax-cart--lock-scroll");

		},

		cartClose: function(){

			$(".ajax-cart")
				.removeClass('ajax-cart--opened')
				.addClass('ajax-cart--closed');

			$(".ajax-cart-overlay").fadeOut();

			$("#ajax-cart").trigger("ajax-cart.cart-close");

			$("body").removeClass("ajax-cart--lock-scroll");

		},

		cartOverlayShow: function(){

			if ( $('.ajax-cart .ajax-cart__body .ajax-cart-contents-overlay').length > 0 ) {
				return;
			}

			var overlay = Shopify.AjaxCart.templates.cartContentsOverlay({ text: "Cart Loading..." });
			var container = $('.ajax-cart .ajax-cart__body');

			overlay = $(overlay)[0];

			container.prepend(overlay);

		},

		cartOverlayHide: function(){

			var overlay = $('.ajax-cart .ajax-cart__body .ajax-cart-contents-overlay');

			$(overlay).remove();

		},

		refreshShipping: function(){
			
			var enableFreeShipping = false;
			
			var freeShipping = (Shopify.AjaxCart.storage.cart.total_price >= Shopify.AjaxCart.settings.freeShippingThreshold && enableFreeShipping === true) ? true : false;
			var shippingBannerText;

			if (freeShipping === true) {

				$('.ajax-cart-banner').addClass('ajax-cart-banner--success');

				shippingBannerText = Shopify.AjaxCart.translations.shipping_banner.text_free_html;

			}
			else {

				$('.ajax-cart-banner').removeClass('ajax-cart-banner--success');

				var moneyFormat = $('body').data('money-format');

				var shippingPriceDifference = Shopify.AjaxCart.settings.freeShippingThreshold - Shopify.AjaxCart.storage.cart.total_price;
				var shippingPriceDifferenceDisplay = Shopify.formatMoney(shippingPriceDifference, moneyFormat);

				shippingBannerText = Shopify.AjaxCart.translations.shipping_banner.text_required_html;
				shippingBannerText = shippingBannerText.replace("SHIPPING_PRICE", shippingPriceDifferenceDisplay)

			}

			$('.ajax-cart-banner__text').html(shippingBannerText);

		},

		refreshCart: function(){

			var cartCount = Shopify.AjaxCart.storage.cart.item_count;
			var cartItems = Shopify.AjaxCart.storage.cart.items;
			var cartContainer = $('.ajax-cart__items');

			if (cartItems.length > 0) {
				showCartItems();
			}
			else {
				showEmptyMessage();
			}

			$('[data-ajaxcart-value]').text(cartCount);
			$('.cart_count').text(cartCount);

			function showEmptyMessage() {

				var html = Shopify.AjaxCart.templates.cartEmptyMessage();

				cartContainer.html(html);

			}

			function showCartItems() {

				var html = "";

				for (var i = 0; i < cartItems.length; i++) {
					html = Shopify.AjaxCart.templates.cartItem(cartItems[i]) + html;
				}

				cartContainer.html(html);

			}

		},

		refreshTotals: function(){

			var moneyFormat = $('body').data('money-format');

			
			var enableFreeShipping = false;
			

			var shippingIsFree = (Shopify.AjaxCart.storage.cart.total_price >= Shopify.AjaxCart.settings.freeShippingThreshold && enableFreeShipping === true) ? true : false;
			var shippingPriceLabel = 'Calculated at Checkout';

			var lineShipping = $('.ajax-cart-statement-line--shipping .ajax-cart-statement-line__value');
			var lineSavings = $('.ajax-cart-statement-line--savings .ajax-cart-statement-line__value');
			var lineVat = $('.ajax-cart-statement-line--vat .ajax-cart-statement-line__value');
			var lineSubtotal = $('.ajax-cart-statement-line--subtotal .ajax-cart-statement-line__value');
			var lineTotal = $('.ajax-cart-statement-line--total .ajax-cart-statement-line__value');

			var valueShipping = shippingIsFree === true | shippingPriceLabel != "" ? 0: Shopify.AjaxCart.settings.shippingPrice;
			var valueShippingDisplay = Shopify.AjaxCart.settings.shippingPriceDisplay;
			var valueSavings = Shopify.AjaxCart.storage.cart.total_discount;
			var valueVat = Shopify.AjaxCart.settings.vat_rate;
			var valueSubtotal = Shopify.AjaxCart.storage.cart.total_price;
			var valueTotal = valueSubtotal - valueSavings + valueShipping;

			var vatSubtotal = parseFloat(valueSubtotal);
			valueVat = (vatSubtotal * (valueVat / 100));
			valueTotal = valueTotal + valueVat;

			var displaySavings = Shopify.formatMoney(valueSavings, moneyFormat);
			var displayVat = Shopify.formatMoney(valueVat, moneyFormat);
			var displaySubtotal = Shopify.formatMoney(valueSubtotal, moneyFormat);
			var displayTotal = Shopify.formatMoney(valueTotal, moneyFormat);
			var displayShipping;

			if (shippingPriceLabel != "") {
				displayShipping = '<span class="ajax-cart-statement-line__shipping-label">' + shippingPriceLabel + '</span>';
			}
			else if (shippingIsFree === true || valueShipping == 0) {
				displayShipping = '<span class="ajax-cart-statement-line__free-shipping">Free</span>';
			}
			else if (valueShipping > 0) {
				displayShipping = '<span class="ajax-cart-statement-line__shipping-price">' + valueShippingDisplay + '</span>';
			}
			else {
				displayShipping = '';
			}

			lineShipping.html(displayShipping);
			lineSavings.html(displaySavings);
			lineVat.html(displayVat);
			lineSubtotal.html(displaySubtotal);
			lineTotal.html(displayTotal);

		},

		addEventListeners: function() {

			$('.ajax-cart__items').on("click", '.ajax-cart-item__remove', Shopify.AjaxCart.eventHandlers.itemRemove);
			$('.ajax-cart__items').on("click", '.ajax-cart-quantity-selector__increment', Shopify.AjaxCart.eventHandlers.onClickItemIncrement);
			$('.ajax-cart__items').on("click", '.ajax-cart-quantity-selector__decrement', Shopify.AjaxCart.eventHandlers.onClickItemDecrement);
			$('.ajax-cart__items').on("change", '.ajax-cart-quantity-selector__quantity', Shopify.AjaxCart.eventHandlers.onChangeItemQuantity);

			$('body').on("click", ".ajax-cart-overlay", Shopify.AjaxCart.eventHandlers.onClickCartClose);

			$('body').on('click', '.ajax-cart--trigger-open', Shopify.AjaxCart.eventHandlers.onClickCartOpen);
			$('body').on('click', '.ajax-cart--trigger-close', Shopify.AjaxCart.eventHandlers.onClickCartClose);
			$('body').on('click', '.ajax-cart--trigger-toggle', Shopify.AjaxCart.eventHandlers.onClickCartToggle);
			$('body').on("click", '.ajax-cart--trigger-submit', Shopify.AjaxCart.eventHandlers.onClickCheckout);
			$('body').on("click", '.ajax-cart--trigger-gotocart', Shopify.AjaxCart.eventHandlers.onClickGoToCart);
			$('body').on("click", '.ajax-cart--trigger-add-upsell', Shopify.AjaxCart.eventHandlers.onClickAddUpsell);
			$('body').on("click", '.ajax-cart--trigger-add-mailing-carton', Shopify.AjaxCart.eventHandlers.onClickAddMailingCarton);
			$('body').on("click", '.ajax-cart--trigger-add-mailing-cartons', Shopify.AjaxCart.eventHandlers.onClickAddAllMailingCartons);

		}

	},

	eventHandlers: {

		onClickGoToCart: function(){
			location.href = '/cart';
		},

		onClickCheckout: function(e){

			e.preventDefault();

			$('.ajax-cart__form').submit();

		},

		onClickCartOpen: function(e){

			e.preventDefault();

			if ( $("body").hasClass("cart") === true ) {
				return;
			}

			Shopify.AjaxCart.functions.cartOpen();

		},

		onClickCartClose: function(e){

			e.preventDefault();
			Shopify.AjaxCart.functions.cartClose();

		},

		onClickCartToggle: function(e){

			e.preventDefault();
			Shopify.AjaxCart.functions.cartToggle();

		},

		onClickAddUpsell: function(e){

			var button = $(e.currentTarget);
			var upsell = button.closest(".ajax-cart-upsell");
			var id = upsell.data("id");

			var options = {
				id: id,
				quantity: 1,
			};

			Shopify.AjaxCart.api.addItem(options);

		},

		onClickAddAllMailingCartons: function(e){

			var button = $(e.currentTarget);

			var mailingCartonCollection;
			var mailingCartonProduct;
			var mailingCartonTag;
			var mailingCartonId;

			// Get all box products in cart.

			var cart_products = Shopify.AjaxCart.storage.cart.items;
			var cart_product;

			var cart_product_tags;
			var cart_product_tag;

			var boxProducts = [];

			var foldabox_sizes = Shopify.Foldabox.storage.sizes;
			var foldabox_size;
			var foldabox_size_tag;

			var product_tag;
			var product_size_tag;

			// Loop through all sizes to get tag for size.

			loop1:
			for (var a = 0; a < cart_products.length; a++) {

				cart_product = cart_products[a];

				/*
					TODO: This is trickier than I thought, because product tags are not
					stored on cart items. Will have to retrieve the products by AJAX and
					then loop through them.
				*/

				// cart_product_tags = cart_product.tags;

				/*

				loop2:
				for (var b = 0; b < cart_product_tags.length; b++) {

					cart_product_tag = cart_product_tags[b];

					if (cart_product_tag == "Box") {

						product_size_tag = product_tag;
						boxProducts.push(cart_product);

					}

				}

				*/

			}

			// Get mailing carton products for each box product.

			// Add mailing carton products to the cart.

		},

		onClickAddMailingCarton: function(e){

			var button = $(e.currentTarget);
			var upsell = button.closest(".ajax-cart-upsell");
			var cart_product = button.closest(".ajax-cart-item");
			var id = cart_product.data("id");
			var handle = cart_product.data("handle");

			var mailingCartonCollection;
			var mailingCartonProduct;
			var mailingCartonTag;
			var mailingCartonId;

			var isSample = button.data("sample") == "true";

			console.log(isSample);

			if (isSample == true) {
				mailingCartonCollection = Shopify.Foldabox.storage.collections.sample_mailing_cartons;
			}
			else {
				mailingCartonCollection = Shopify.Foldabox.storage.collections.mailing_cartons;
			}

			var options = {

			};

			Shopify.AjaxCart.api.getMailingCartonProduct({

				handle: handle,

				success: function(data){

					var product_tags = data.tags;

					var foldabox_sizes = Shopify.Foldabox.storage.sizes;
					var foldabox_size;
					var foldabox_size_tag;

					var product_tag;
					var product_size_tag;

					// Loop through all sizes to get tag for size.

					loop1:
					for (var a = 0; a < product_tags.length; a++) {

						product_tag = product_tags[a];

						loop2:
						for (var b = 0; b < foldabox_sizes.length; b++) {

							foldabox_size = foldabox_sizes[b];
							foldabox_size_tag = foldabox_size.tag;

							if (foldabox_size_tag == product_tag) {

								product_size_tag = product_tag;
								break loop1;

							}

						}

					}

					// Get Product

					loop3:
					for (var c = 0; c < mailingCartonCollection.length; c++) {

						mailingCartonProduct = mailingCartonCollection[c];

						loop4:
						for (var d = 0; d < mailingCartonProduct.tags.length; d++) {

							mailingCartonTag = mailingCartonProduct.tags[d];

							if (product_size_tag == mailingCartonTag) {

								mailingCartonId = mailingCartonProduct.id;
								break loop3;

							}

						}

					}

					try {

						var options = {
							id: mailingCartonId.toString(),
							quantity: 1,
							error: function(){
								alert(Shopify.AjaxCart.translations.upsells.mailing_carton.out_of_stock);
							}
						};

						Shopify.AjaxCart.api.addItem(options);

					} catch (e) {

						console.log(e);

						Shopify.AjaxCart.functions.cartOverlayHide();

					}



				}

			});

		},

		onClickItemIncrement: function(e){

			var button = $(e.currentTarget);
			var selector = button.closest('.ajax-cart-quantity-selector');
			var input = selector.find('.ajax-cart-quantity-selector__quantity');
			var value = input.val();

			value++;
			input.val(value);

			input.trigger("change");

		},

		onClickItemDecrement: function(e){


			var button = $(e.currentTarget);
			var selector = button.closest('.ajax-cart-quantity-selector');
			var input = selector.find('.ajax-cart-quantity-selector__quantity');
			var value = input.val();

      var type = button.closest('.ajax-cart-item').data('type');
      var is_usa = $("#ajax-cart").data('is_usa');

      if(type == 'Box'){
        if(is_usa){
          if(value > 2){
            value--;
          }
        }
        else{
          value--;
        }
      }
      else{
        value--;
      }


			input.val(value);
			input.trigger("change");

		},

		onChangeItemQuantity: function(e){

      var is_usa = $("#ajax-cart").data('is_usa');
			var input = $(e.currentTarget);
			var item = input.closest(".ajax-cart-item");
			var id = item.data("id");
			var quantity = input.val();

      var type = input.closest('.ajax-cart-item').data('type');

      if(type == 'Box' && is_usa){
        if(quantity < 2){
          input.value = 2;
          quantity = 2;
          console.log("not 2 or greater");
        }
      }

      console.log("value", quantity);

			Shopify.AjaxCart.api.changeItemQuantity({
				id: id,
				quantity: quantity
			});

		},

		itemRemove: function(e){

			var input = $(e.currentTarget);
			var item = input.closest(".ajax-cart-item");
			var id = item.data("id");
			var quantity = input.val();

			Shopify.AjaxCart.api.changeItemQuantity({
				id: id,
				quantity: 0
			});

		}

	},

	init: function(){

		Shopify.AjaxCart.functions.addEventListeners();
		Shopify.AjaxCart.api.updateCart();

	}

};

Shopify.AjaxCart.init();
